import { safeParse } from '@debbie/common/dist/util/json.js';
import { isEqual } from 'lodash-es';
import { useCallback } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
// A param is taken as is when the schema accepts the string, otherwise as JSON,
// mirroring how toQuery writes values. Missing or invalid params read as the
// default.
export const parseUrlParam = (key, schema, defaultValue, search) => {
    const param = new URLSearchParams(search).get(key);
    if (param == null) {
        return defaultValue;
    }
    const asString = schema.safeParse(param);
    if (asString.success) {
        return asString.data;
    }
    const asJson = safeParse(param, schema);
    return asJson.ok ? asJson.data : defaultValue;
};
// Leaves other params untouched, and drops the param when set to its default.
export const updateUrlParam = (key, defaultValue, search, value) => {
    const params = new URLSearchParams(search);
    if (isEqual(value, defaultValue)) {
        params.delete(key);
    }
    else {
        params.set(key, typeof value === 'string' ? value : JSON.stringify(value));
    }
    return params.toString();
};
// useState backed by a query parameter. Each update starts from the current
// URL rather than the rendered one, so consecutive updates don't overwrite each
// other whether or not React batches them.
export const useUrlState = (key, schema, defaultValue) => {
    const history = useHistory();
    const { search } = useLocation();
    const setValue = useCallback((value) => history.replace({
        search: updateUrlParam(key, defaultValue, history.location.search, value),
    }), [history, key, defaultValue]);
    return [parseUrlParam(key, schema, defaultValue, search), setValue];
};
//# sourceMappingURL=url-state.js.map